import { CheckboxGroupInput, CheckboxGroupInputProps } from "react-admin";
import { Column } from "../misc/Column";
import { FormLabel } from "@mui/material";
import { FilterModeDropdownMenu } from "./FilterModeDropdownMenu";

export function CheckboxGroupInput2(props: CheckboxGroupInputProps & { withMode?: boolean }) {
  const { sx, withMode, label, source, ...rest } = props;
  return (
    <CheckboxGroupInput
      {...rest}
      source={source}
      label={<InputLabelWithMode label={label} source={source} withMode={withMode} />}
      sx={{
        "& .MuiFormLabel-root": {
          fontWeight: 600,
          color: "text.primary",
          mb: 0.8,
        },
        "& .MuiFormControlLabel-label": {
          fontSize: "14px",
        },
        ...sx,
      }}
    />
  );
}

function InputLabelWithMode(props: {
  withMode?: boolean;
  source?: string;
  label?: string | React.ReactNode;
}): React.ReactNode | null {
  const { label, source, withMode = false } = props;
  if (!label || !source) return null;
  if (withMode) {
    return (
      <Column>
        <FormLabel sx={{ fontSize: "14px !important" }}>{label}</FormLabel>
        <FilterModeDropdownMenu source={source} />
      </Column>
    );
  }
  return <FormLabel sx={{ fontSize: "14px !important" }}>{label}</FormLabel>;
}
